import { post, get } from './http';

export const getPromptList = () => {
    var params = {};
    return get('/sa/prompt/list', params);
};

export const createPrompt = (title, content, temperature) => {
    var params = { title, content, temperature };
    return post('/sa/prompt/create', params);
};

export const updatePrompt = (id, title, content, temperature) => {
    var params = { id, title, content, temperature };
    return post('/sa/prompt/update', params);
};
